import actions from "./actions";

const defaultState = {
    consents: [],
    consent: {}
};

export default function consentTypesReducer(state = defaultState, action: { type: string; payload: any; }): any {
    switch (action.type) {
        case actions.SET_DATA:
            return {...state, consents: action.payload};
        case actions.SET_CONSENT:
            return {...state, consent: action.payload};
        default:
            return state
    }
}
